
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/destinasyon-360.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import PrivacyPolicy from "views/legal/PrivacyPolicy";
import UserPrivacy from "views/legal/UserPrivacy";
import SupportPage from "views/legal/SupportPage";
import AdminDataGate from "components/admin/AdminDataGate";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AdminDataGate>
    <BrowserRouter>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/user-privacy" element={<UserPrivacy />} />
        <Route path="/destek" element={<SupportPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/admin/*" element={<AdminLayout />} />
        <Route path="/auth/*" element={<AuthLayout />} />
        <Route path="*" element={<Navigate to="/admin/index" replace />} />
      </Routes>
    </BrowserRouter>
  </AdminDataGate>
);
